/* eslint-disable object-curly-spacing */
import React from 'react';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

/**
 * This function renders the Coronavirus page
 * @component CoronavirusPage
 * @return {Component} CoronavirusPage component
 */
export default function CoronavirusPage() {
  return (
    <div className="support-container">
      <Card
        style={{
          padding: '50px',
          margin: '0 auto',
        }}
      >
        <Typography variant="h6" gutterBottom>
          <h1>Coronavirus Update</h1>
        </Typography>
        <Divider />
        <br />
        <div style={{ fontSize: '18px', lineHeight: '1.5' }}>
          7/6/2022 – The Advanced Intelligence Services Corporation is a private
          physics research company and does not diagnose or treat COVID-19
          cases. Our company is conducting standard administrative business by
          remote function at this time. project.
        </div>
        <br />
      </Card>
      <div style={{ height: '200px' }}></div>
    </div>
  );
}
